<template>
  <div>
    <!-- <div class="title-data">有效认证证书分布区域图</div> -->
    <div id="zhutitu" style="width: 500px;height:400px;float: left;"></div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  export default {

    data() {
      return {
        charts: '',
      }
    },

    mounted() {
      this.$axios.get("/api/webConfigs").then(res => {
        if(res.data)
          {
              let sexRatio = res.data.data[0].sexRatio;
              let arrsexRatio = sexRatio.split("|");
              let mancount = arrsexRatio[0];
              let womancount = arrsexRatio[1];
              this.init("zhutitu",mancount,womancount)
          }
      });
      
    },

    methods: {
      init(id,mancount,womancount) {
        this.charts = echarts.init(document.getElementById(id))

        let colorList = [[
          '#ff7f50', '#87cefa', '#da70d6', '#32cd32', '#6495ed',
          '#ff69b4', '#ba55d3', '#cd5c5c', '#ffa500', '#40e0d0',
          '#1e90ff', '#ff6347', '#7b68ee', '#d0648a', '#ffd700',
          '#6b8e23', '#4ea397', '#3cb371', '#b8860b', '#7bd9a5'
        ],
        [
          '#ff7f50', '#87cefa', '#da70d6', '#32cd32', '#6495ed',
          '#ff69b4', '#ba55d3', '#cd5c5c', '#ffa500', '#40e0d0',
          '#1e90ff', '#ff6347', '#7b68ee', '#00fa9a', '#ffd700',
          '#6b8e23', '#ff00ff', '#3cb371', '#b8860b', '#30e0e0'
        ],
        [
          '#929fff', '#9de0ff', '#ffa897', '#af87fe', '#7dc3fe',
          '#bb60b2', '#433e7c', '#f47a75', '#009db2', '#024b51',
          '#0780cf', '#765005', '#e75840', '#26ccd8', '#3685fe',
          '#9977ef', '#f5616f', '#f7b13f', '#f9e264', '#50c48f'
        ]][2];

        let option = {
           title : {
              text: '认证性别数据统计',
              x:'center'
          },
          tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
              orient: 'vertical',
              left: '15',
              bottom: '10',
              data: ['男性人数','女性人数']
          },
           color : [ '#7bd9a5',  '#87cefa',],
          series : [
              {
                  name: '男性人数',
                  type: 'pie',
                  radius : '50%',
                  center: ['75%', '40%'],
                  data:[
                      {value:mancount, name:'男性人数'}
                  ],
                  label:{
                    normal:{
                      show: true,
                      position: 'inner',
                    }
                  },
                  itemStyle: {
                      emphasis: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  }
              },
              {
                  name: '女性人数',
                  type: 'pie',
                  radius: '40%',
                  center: ['35%', '65%'],
                  label:{
                    normal:{
                      show: true,
                      position: 'inner',
                      'font-size':'24px'
                    }
                  },
                  data: [
                      {
                        value: womancount, 
                        name: '女性人数',
                        symbolSize: 56}
                      ]
              }
          ]
        }
        //跳转代码
        this.charts.on('click', function (params) {
        });

        // 使用刚指定的配置项和数据显示图表。
        this.charts.setOption(option);
      }
    },

  }
</script>
<style scoped>
.title-data{
    font-size:27px;
    margin:13px 13px;
    text-align: center;
  }
</style>